var _excluded = ["fillColor"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
var SvgCardDinner = function SvgCardDinner(_ref) {
  var fillColor = _ref.fillColor,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: fillColor || "#FFF",
    stroke: fillColor || "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    d: "M21.997 15.75H22c.955.008 1.74-.773 1.751-1.746V2.006a1.8 1.8 0 0 0-.52-1.25A1.72 1.72 0 0 0 21.997.25H2.001A1.72 1.72 0 0 0 .77.757c-.33.33-.517.779-.521 1.247v11.99c.004.47.191.92.52 1.25.329.328.771.51 1.233.506zm0 .5h-.002.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor || "#0165AC",
    d: "M10.002 2.052v-.016h4v.016a6 6 0 0 1 0 11.968v.016h-4v-.016a6 6 0 0 1 0-11.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor || "#FFF",
    d: "M11.602 11.428a3.6 3.6 0 0 0 0-6.784zm-2.4-6.784a3.6 3.6 0 0 0 0 6.784zm1.2 8.592a5.2 5.2 0 1 1 0-10.4 5.2 5.2 0 0 1 0 10.4"
  })));
};
export default SvgCardDinner;